// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__2geev","label":"Section_label__K43ap","contentWrap":"Section_contentWrap__3atJ-","footer":"Section_footer__3IRGa","footerInner":"Section_footerInner__1QMyP"};